import React from 'react';
import { Container, Graphics } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import LastWinWrapper from '../../common/lastWinWrapper';
import BottomLeft from '../../../components/web/bottomLeft';
import { menuSectionStore } from '../../../store/menuSectionStore';
import ClassicBettingPartWrapper from '../../common/classicBettingPartWrapper';
import { userInfoStore } from '../../../store/userInfoStore';

const WebBottomContainer = observer(() => {
  const { isShowMenuPopup } = menuSectionStore;
  const { isReplay } = userInfoStore;

  return (
    <Container visible={!isShowMenuPopup} name='BottomContainer'>
      <BottomLeft />
      <LastWinWrapper />
      <ClassicBettingPartWrapper />
      <Graphics
        draw={(g) => {
          g.clear();
          g.beginFill(0x030303);
          g.alpha = 0;
          g.drawRect(370, 600, 1100, 200);
          g.interactive = isReplay;
          g.visible = isReplay;
        }}
      />
    </Container>
  );
});

export default WebBottomContainer;
